import Collapsible from "./collapsible";

export default Collapsible;
